import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Globe, Check } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";

export default function LanguageSwitcher({ scrolled }) {
  const { lang, setLang, languages } = useLang();
  const [open, setOpen] = useState(false);
  const current = languages.find((l) => l.code === lang);

  return (
    <div className="relative" data-testid="language-switcher">
      <button
        data-testid="language-toggle"
        onClick={() => setOpen((v) => !v)}
        onBlur={() => setTimeout(() => setOpen(false), 150)}
        className={`flex items-center gap-2 rounded-full border px-3.5 py-2 text-sm transition-colors ${
          scrolled
            ? "border-[#3A4536]/20 text-[#1A2118] hover:bg-[#EAE5D9]"
            : "border-[#3A4536]/20 text-[#1A2118] hover:bg-[#EAE5D9]/60"
        }`}
        aria-label="Change language"
      >
        <Globe strokeWidth={1.5} className="h-4 w-4 text-[#B85D43]" />
        <span className="overline">{current?.short}</span>
      </button>

      <AnimatePresence>
        {open && (
          <motion.ul
            initial={{ opacity: 0, y: -8 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -8 }}
            transition={{ duration: 0.2 }}
            className="absolute right-0 z-50 mt-2 w-44 overflow-hidden rounded-[4px] border border-[#3A4536]/15 bg-[#F4F1EB] shadow-lg"
          >
            {languages.map((l) => (
              <li key={l.code}>
                <button
                  data-testid={`language-option-${l.code}`}
                  onMouseDown={(e) => {
                    e.preventDefault();
                    setLang(l.code);
                    setOpen(false);
                  }}
                  className="flex w-full items-center justify-between px-4 py-2.5 text-left text-sm text-[#1A2118] transition-colors hover:bg-[#EAE5D9]"
                >
                  <span>{l.label}</span>
                  {l.code === lang && <Check strokeWidth={2} className="h-4 w-4 text-[#B85D43]" />}
                </button>
              </li>
            ))}
          </motion.ul>
        )}
      </AnimatePresence>
    </div>
  );
}
